import { SettlementConstants } from 'constants/settlement';
import { createAction } from 'redux-actions';

export const getSettlements = createAction(SettlementConstants.GET_SETTLEMENTS);
export const confrimCDA = createAction(SettlementConstants.CONFIRM_CDA);
export const updateCounterOfferStatus = createAction(SettlementConstants.UPDATE_COUNTER_OFFER_STATUS);
export const getBankAccountDetails = createAction(SettlementConstants.GET_BANK_DETAILS);



// WEBPACK FOOTER //
// ./src/actions/settlement.js